module.exports = __webpack_public_path__ + "img/Perks-10.04309c90.png";